(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    class ProductModal extends ModalDialog {
        constructor() {
            super();
            this.mediaItems = [];
            this.currentIndex = 0;
            this.isNavigating = false;
            this.navigationTimeout = null;
            
            // Navegación con teclado
            this.addEventListener('keydown', (event) => {
                if (!this.hasAttribute('open')) return;
                
                if (event.code === 'ArrowLeft') {
                    event.preventDefault();
                    this.navigatePrevious();
                } else if (event.code === 'ArrowRight') {
                    event.preventDefault();
                    this.navigateNext();
                }
            });
            
            // Navegación con clics
            this.addEventListener('mousedown', (event) => {
                const prevNav = event.target.closest('.product-media-modal__nav--prev');
                const nextNav = event.target.closest('.product-media-modal__nav--next');
                
                if (prevNav || nextNav) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    
                    this.setNavigating();
                    
                    if (prevNav) {
                        this.navigatePrevious();
                    } else {
                        this.navigateNext();
                    }
                    
                    return false;
                }
            }, true);
            
            // Prevenir clicks
            this.addEventListener('click', (event) => {
                const prevNav = event.target.closest('.product-media-modal__nav--prev');
                const nextNav = event.target.closest('.product-media-modal__nav--next');
                
                if (prevNav || nextNav || this.isNavigating) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;
                }
            }, true);
        }
        
        setNavigating() {
            this.isNavigating = true;
            
            if (this.navigationTimeout) {
                clearTimeout(this.navigationTimeout);
            }
            
            this.navigationTimeout = setTimeout(() => {
                this.isNavigating = false;
            }, 500);
        }
        
        hide() {
            if (this.isNavigating) {
                return;
            }
            
            // Pausar todos los videos al cerrar
            this.pauseAllVideos();
            
            super.hide();
        }
        
        show(opener) {
            super.show(opener);
            this.showActiveMedia();
            
            // Actualizar lista de imágenes
            this.mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content-info'));
            
            // Encontrar el índice de la imagen activa
            const activeMedia = this.querySelector('.product-media-modal__content-info.active');
            if (activeMedia) {
                this.currentIndex = this.mediaItems.indexOf(activeMedia);
            }
        }
        
        showActiveMedia() {
            this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
                element.classList.remove('active');
            })
            const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
            const activeMediaTemplate = activeMedia.querySelector('template');
            const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
            activeMedia.classList.add('active');
            activeMedia.scrollIntoView();
            const container = this.querySelector('[role="document"]');
            container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
            if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
                activeMedia.loadContent();
        }
        
        pauseAllVideos() {
            // Pausar videos nativos
            this.querySelectorAll('video').forEach(video => {
                video.pause();
            });
            
            // Pausar videos de YouTube/Vimeo (recargar iframe)
            this.querySelectorAll('.product-media-modal__external-video iframe').forEach(iframe => {
                const src = iframe.src;
                iframe.src = src;
            });
        }
        
        navigatePrevious() {
            if (this.mediaItems.length === 0) return;
            
            this.setNavigating();
            
            // Pausar videos antes de cambiar
            this.pauseAllVideos();
            
            this.mediaItems[this.currentIndex].classList.remove('active');
            
            this.currentIndex--;
            if (this.currentIndex < 0) {
                this.currentIndex = this.mediaItems.length - 1;
            }
            
            this.mediaItems[this.currentIndex].classList.add('active');
            this.mediaItems[this.currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        
        navigateNext() {
            if (this.mediaItems.length === 0) return;
            
            this.setNavigating();
            
            // Pausar videos antes de cambiar
            this.pauseAllVideos();
            
            this.mediaItems[this.currentIndex].classList.remove('active');
            
            this.currentIndex++;
            if (this.currentIndex >= this.mediaItems.length) {
                this.currentIndex = 0;
            }
            
            this.mediaItems[this.currentIndex].classList.add('active');
            this.mediaItems[this.currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }
    customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
